import Circuit from "~/components/circuit"
import { Button, Spinner, Switch, SelectMenu } from "evergreen-ui"
import Banner from "~/components/banner"
import Figure from "~/components/figure"

const defaultCircuits = {
  inceptionv1: [
    {
      name: "mixed3b",
      modules: [{ name: "Oriented Fur", neurons: [404, 333] }],
    },
    {
      name: "mixed4a",
      modules: [
        { name: "Head Right", neurons: [308, 234] },
        { name: "Head Left", neurons: [222, 325] },
      ],
    },
    {
      name: "mixed4b",
      modules: [
        { name: "Head + Neck Left", neurons: [429, 384] },
        { name: "Head + Neck Right", neurons: [443, 431] },
      ],
    },
  ],
  alexnet: [
    {
      name: "conv1_1",
      modules: [{ name: "edges", neurons: [28, 37, 54, 64] }],
    },
    {
      name: "conv2_1",
      modules: [{ name: "edges", neurons: [110, 130, 131, 75, 83] }],
    },
    {
      name: "conv3_1",
      modules: [
        { name: "shallow curves", neurons: [186, 32, 147, 313, 320] },
        {
          name: "curves",
          neurons: [277, 348, 319, 257, 125, 253, 369, 282, 289],
        },
        { name: "edges", neurons: [168, 70, 317] },
      ],
    },
  ],
}

class Editor extends Component {
  state = { newValue: "" }

  componentWillMount() {
    this.setState({ newValue: this.props.value })
  }

  componentWillReceiveProps({ value }) {
    this.setState({ newValue: value })
  }

  render() {
    const { newValue } = this.state
    const { onChange } = this.props

    return (
      <Surface>
        <textarea
          style={{ height: 400 }}
          value={newValue}
          onChange={e => {
            this.setState({ newValue: e.target.value })
          }}
        />
        <Surface flexFlow="row" alignItems="center">
          <div>
            <Button margin={10} size={600} onClick={() => onChange(newValue)}>
              Render
            </Button>
          </div>
        </Surface>
      </Surface>
    )
  }
}

const defaultModel = "inceptionv1"
export default class CircuitEditor extends Component {
  state = {
    circuit: defaultCircuits[defaultModel],
    isDesigner: true,
    newCircuit: JSON.stringify(defaultCircuits[defaultModel], null, 2),
    loading: false,
    circuitState: {
      activeNeurons: null,
      maxScales: null,
      recommendModal: null,
    },
    isShowingEditor: true,
    modelName: defaultModel,
  }

  getGist = async url => {
    const id = url.split("/").slice(-1)[0]
    const api = `https://api.github.com/gists/${id}`
    const json = await (await fetch(api)).json()
    const obj = JSON.parse(Object.values(json.files)[0].content)
    this.setState({
      circuit: obj,
      newCircuit: JSON.stringify(obj, null, 2),
      loading: false,
    })
  }

  componentWillMount() {
    if ((window.location + "").indexOf("gist=") > -1) {
      this.getGist((window.location + "").split("gist=")[1])
    } else {
      this.setState({
        loading: false,
      })
    }
  }

  updateCircuit = fn => {
    const circuit = fn(this.state.circuit)
    this.setState({ newCircuit: JSON.stringify(circuit, null, 2), circuit })
  }

  onAddLayerBefore = name => {
    this.updateCircuit(circuit => {
      return [
        {
          name,
          modules: [],
        },
        ...circuit,
      ]
    })
  }

  onAddLayerAfter = name => {
    this.updateCircuit(circuit => {
      return [
        ...circuit,
        {
          name,
          modules: [],
        },
      ]
    })
  }

  onAddGroup = (layerName, groupName) => {
    this.updateCircuit(circuit => {
      return circuit.map(layer => {
        if (layer.name !== layerName) return layer

        layer.modules = [
          {
            name: groupName,
            neurons: [],
          },
          ...layer.modules,
        ]
        return layer
      })
    })
  }

  onAddNeuron = (layerName, moduleName, neuron) => {
    this.updateCircuit(circuit => {
      return circuit.map(layer => {
        if (layer.name !== layerName) return layer

        layer.modules = layer.modules.map(group => {
          if (group.name !== moduleName) return group

          group.neurons = [...group.neurons, neuron]

          return group
        })

        return layer
      })
    })
  }

  onSetModel = modelName => {
    const circuit = defaultCircuits[modelName]
    this.setState({
      modelName,
      newCircuit: JSON.stringify(circuit, null, 2),
      circuit,
    })
  }

  render() {
    const {
      circuit,
      loading,
      isDesigner,
      circuitState,
      isShowingEditor,
      newCircuit,
      modelName,
    } = this.state

    if (loading) {
      return (
        <Surface margin={20}>
          <Spinner />
        </Surface>
      )
    }

    const modelOptions = [
      { label: "InceptionV1", value: "inceptionv1" },
      { label: "AlexNet", value: "alexnet" },
    ]

    return (
      <React.Fragment>
        <Banner
          title="Designer"
          subtitle="An interactive tool to discover and study circuits"
          rightContent={
            <Surface>
              <Surface flexFlow="row" alignItems="center">
                <Surface flexFlow="row" alignItems="center">
                  <Text marginRight={10} fontSize={18}>
                    Designer Mode
                  </Text>
                  <Switch
                    height={20}
                    checked={isDesigner}
                    onChange={() => this.setState({ isDesigner: !isDesigner })}
                  />
                </Surface>
                {true && (
                  <Surface marginLeft={30}>
                    <SelectMenu
                      title="Select Model"
                      options={modelOptions}
                      selected={modelName}
                      onSelect={({ value }) => this.onSetModel(value)}
                    >
                      <Button size={500}>{`model: ${modelName}`}</Button>
                    </SelectMenu>
                  </Surface>
                )}
              </Surface>
            </Surface>
          }
          noAuthors
        />
        <Figure>
          <Circuit
            key={1}
            isDesigner={isDesigner}
            circuit={circuit}
            onAddNeuron={this.onAddNeuron}
            onAddGroup={this.onAddGroup}
            onAddLayerBefore={this.onAddLayerBefore}
            onAddLayerAfter={this.onAddLayerAfter}
            key={JSON.stringify(circuit) + modelName}
            circuitState={circuitState}
            onChangeState={circuitState => {
              this.setState({
                circuitState: Object.assign(
                  {},
                  this.state.circuitState,
                  circuitState,
                ),
              })
            }}
            modelName={modelName}
          />
        </Figure>
        <Surface flexFlow="row" alignItems="center" marginY={10}>
          <Text marginRight={5} fontSize={18}>
            Show Editor
          </Text>
          <Switch
            height={20}
            checked={isShowingEditor}
            onChange={() =>
              this.setState({ isShowingEditor: !isShowingEditor })
            }
          />
        </Surface>
        {isShowingEditor && (
          <Editor
            value={newCircuit}
            onChange={value =>
              this.setState({
                circuit: JSON.parse(value),
                newCircuit: value,
                recommendModal: null,
                circuitState: { activeNeurons: null, maxScales: null },
              })
            }
          />
        )}
      </React.Fragment>
    )
  }
}
